/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { SendOtpRequest } from '../model';
// @ts-ignore
import { VerifyOtpRequest } from '../model';
// @ts-ignore
import { VerifyOtpResponse } from '../model';
/**
 * OtpControllerApi - axios parameter creator
 * @export
 */
export const OtpControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SendOtpRequest} sendOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOtp: async (sendOtpRequest: SendOtpRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendOtpRequest' is not null or undefined
            assertParamExists('sendOtp', 'sendOtpRequest', sendOtpRequest)
            const localVarPath = `/otp/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyOtpRequest} verifyOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOtp: async (verifyOtpRequest: VerifyOtpRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyOtpRequest' is not null or undefined
            assertParamExists('verifyOtp', 'verifyOtpRequest', verifyOtpRequest)
            const localVarPath = `/otp/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OtpControllerApi - functional programming interface
 * @export
 */
export const OtpControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OtpControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SendOtpRequest} sendOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendOtp(sendOtpRequest: SendOtpRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendOtp(sendOtpRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {VerifyOtpRequest} verifyOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyOtp(verifyOtpRequest: VerifyOtpRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyOtpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyOtp(verifyOtpRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OtpControllerApi - factory interface
 * @export
 */
export const OtpControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OtpControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {SendOtpRequest} sendOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOtp(sendOtpRequest: SendOtpRequest, options?: any): AxiosPromise<void> {
            return localVarFp.sendOtp(sendOtpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VerifyOtpRequest} verifyOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOtp(verifyOtpRequest: VerifyOtpRequest, options?: any): AxiosPromise<VerifyOtpResponse> {
            return localVarFp.verifyOtp(verifyOtpRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OtpControllerApi - object-oriented interface
 * @export
 * @class OtpControllerApi
 * @extends {BaseAPI}
 */
export class OtpControllerApi extends BaseAPI {
    /**
     * 
     * @param {SendOtpRequest} sendOtpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtpControllerApi
     */
    public sendOtp(sendOtpRequest: SendOtpRequest, options?: AxiosRequestConfig) {
        return OtpControllerApiFp(this.configuration).sendOtp(sendOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VerifyOtpRequest} verifyOtpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtpControllerApi
     */
    public verifyOtp(verifyOtpRequest: VerifyOtpRequest, options?: AxiosRequestConfig) {
        return OtpControllerApiFp(this.configuration).verifyOtp(verifyOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

